import Link from 'next/link'

import { getPage } from '@/lib/get-page'
import { decodeSafeEntities } from '@/lib/sanitise-strings'

export default async function PostBusiness({ businessId }: { businessId: number | null }) {
  if (!businessId) {
    return null
  }

  const businessData = await getPage(businessId, ['title', 'link'])

  const companyName = businessData?.title?.rendered || ''
  const url = businessData?.link || ''

  if (!companyName) {
    return null
  }

  return (
    <div className="flex items-center gap-x-xxs">
      {url ? (
        <Link href={url} className="hover:text-link">
          {decodeSafeEntities(companyName)}
        </Link>
      ) : (
        <span>{decodeSafeEntities(companyName)}</span>
      )}
    </div>
  )
}
